import { trigger, transition, style, group, animate } from '@angular/animations';

export const showButtonAnimaton = trigger('showButton', [
  // state('void', style({ 'overflow': 'hidden' })),

  // state('void', style({'height': '0px', 'overflow': 'hidden' })),
  transition(':enter', [
    style({ opacity: 0, height: 0, overflow: 'hidden' }),

    animate(
      '.15s ease-out',
      style({
        opacity: 1,
        height: '*',
      }),
    ),
  ]),
  transition(':leave', [
    style({ overflow: 'hidden', height: '*', opacity: 1 }),

    animate(
      '.15s 0s ease-in',
      style({
        opacity: 0,
        height: '0px',
      }),
    ),
  ]),
]);
